<template>
  <div v-if="data !== null">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="5" :numberOfVisitedDots="4" />
          <div class="clearfix"></div>
          <div class="header-wrapper">
            <h2 class="text-primary-fh" v-html="data.screening.cholesterolheader"></h2>
          </div>
          <div class="clearfix"></div>
          <p v-html="data.screening.cholesteroltext"></p>
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="btn-group btn-group-toggle">
            <label class="btn btn-primary btn-lg radio-btn" :class="choice === 'Yes' ? 'active': ''">
              <input type="radio"
              v-model="choice"
              v-bind:value="'Yes'"
              autocomplete="off">Ja
            </label>
            <div class="clearfix"></div>
            <label class="btn btn-primary btn-lg radio-btn" :class="choice === 'No' ? 'active': ''">
              <input type="radio"
              v-model="choice"
              v-bind:value="'No'"
              autocomplete="off">Nej
            </label>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="verifyCol()" :disabled="choice.length === 0">Nästa</button>
          <div class="clearfix"></div>
            <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
          <div class="clearfix"></div>
          <small class="pull-left">Tryck på <b>Nästa</b> för att gå vidare.</small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import FieldId from '../plugins/fieldId'
import { request } from '../plugins/datocms'

export default {
  name: 'screeningcol',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null,
      choice: ''
    }
  },
  methods: {
    verifyCol () {
      if (this.choice === 'No') {
        let loader = this.$loading.show()
        const fieldId = FieldId()
        const answer = {
          question: 'Har du testat ditt kolesterol tidigare?',
          answer: 'Nej',
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), fieldId).then((response) => {
          if (response.status === 200) {
            loader.hide()
            this.$router.push('createremittance')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      } else {
        this.$router.push('screeningcolvals')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            cholesterolheader
            cholesteroltext
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 110px;
  margin-bottom: 50px;
  min-height: 60vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.pull-left {
  float: left !important;
}
.btn-group {
  display: flex;
}
.radio-btn {
  border-color: #069ccc;
  background: #fff;
  color: #fff;
  font-size: 1em;
  border-radius: .3rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScreeningCholesterol.vue